import { useCallback } from 'react';
import { ScenarioOutletContext } from '@/types';
import { useOutletContext } from 'react-router-dom';
import { Content, useToast } from '@kinesis/bungle';
import { Loading } from '@/components/loading';
import { ScenarioOutputs } from '@/components/scenario-outputs';
import {
  useSimulationQuery,
  useDownloadScenarioMutation,
} from '@/api/scenarios';
import { useScenarioId } from '@/hooks/use-scenario-id';

const ScenarioSimulation = () => {
  const scenarioId = useScenarioId();
  const toast = useToast('globalTop');
  const { scenario } = useOutletContext<ScenarioOutletContext>();
  const [downloadScenario] = useDownloadScenarioMutation();
  const { data: simulation, isLoading: isLoadingSimulation } =
    useSimulationQuery({ scenarioId, interventions: scenario.interventions });

  const onDownload = useCallback(async () => {
    try {
      await downloadScenario({
        scenarioId,
        interventions: scenario.interventions,
      }).unwrap();
    } catch (e) {
      toast('Could not download scenario.', { variant: 'error' });
    }
  }, [toast, downloadScenario, scenarioId, scenario]);

  if (isLoadingSimulation) {
    return <Loading />;
  }
  if (!isLoadingSimulation && simulation) {
    return (
      <Content padding='medium'>
        <ScenarioOutputs simulation={simulation} onDownload={onDownload} />;
      </Content>
    );
  }
  return null;
};

export { ScenarioSimulation };
